import { cn } from '@/lib/utils';
import { getDashboardTileClassName, getDashboardTileOrder } from '@/utils/dashboardTileLayout';

/**
 * Mixed-size dashboard tile board — CSS grid with dense packing (no section gaps).
 */
export function DashboardTile({ tileId, children, className }) {
  return (
    <div
      className={cn(getDashboardTileClassName(tileId), className)}
      data-testid={`dashboard-tile-${tileId}`}
    >
      <div className="h-full min-h-0">{children}</div>
    </div>
  );
}

export function DashboardTileGrid({ tiles = [], className }) {
  const sorted = [...tiles].sort(
    (a, b) => getDashboardTileOrder(a.id) - getDashboardTileOrder(b.id)
  );

  const rendered = sorted
    .map(({ id, render }) => {
      const content = render();
      if (content == null) return null;
      return (
        <DashboardTile key={id} tileId={id}>
          {content}
        </DashboardTile>
      );
    })
    .filter(Boolean);

  if (rendered.length === 0) return null;

  return (
    <div
      className={cn(
        'grid grid-cols-12 gap-4 lg:gap-6 grid-flow-dense items-stretch',
        className
      )}
      data-testid="dashboard-tile-grid"
    >
      {rendered}
    </div>
  );
}

export default DashboardTileGrid;
